angular.module('main')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('relatorios_folhapagamento', {
                url: "/relatorios/folha-pagamento",
                template: require('html-loader!./folha-pagamento.html'),
                controller: 'FolhaPagamentoController',
                controllerAs: 'flh_pagam_cntrllr'
            })
    }])